import { z } from 'zod';
import { FIND_OPTIONS_ORDER_VALUE_SCHEMA, LESS_THAN_SCHEMA } from '../../../../common/schema.ts';
import { NOTE_MAX_LENGTH } from '../../../../entities/CashTransaction/common/constants.ts';

export const POST_SCHEMA = z.object({
  amount: z.number(),
  from: z.number().describe('The debitor account number'),
  note: z.string().max(NOTE_MAX_LENGTH).optional(),
});

const MIN_LIMIT = 3;
const MAX_LIMIT = 30;
export const DEFAULT_LIMIT = 10;
export const DEFAULT_ORDER = { createdAt: 'DESC' } as const;

export const GET_SCHEMA = z.object({
  where: z.object({
    id: LESS_THAN_SCHEMA.optional(),
  }).optional(),
  order: z.object({
    createdAt: FIND_OPTIONS_ORDER_VALUE_SCHEMA,
  }).optional(),
  take: z
    .coerce
    .number()
    .min(MIN_LIMIT)
    .max(MAX_LIMIT)
    .optional(),
});